import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import MetaTags from '../molecules/MetaTags';
import { sharing } from '../data/sharing';

const Holder = styled.div`
	margin-top: 3rem;
	input {
		width: 100%;
		${props => props.theme.typeStyles( 1 )};
		line-height: 4rem;
		font-weight: normal;
		margin: 0 0 .5rem;
		border-color: transparent;
		background-color: ${props => props.theme.colours.lightGrey2};
	}
	button { 
		width: 100%;
		transition: 150ms ease-in;
		transition-property: color, background-color; 
		&.copied {
			color: ${props => props.theme.colours.white};
			background-color: ${props => props.theme.colours.focus};
		}
	}
`;

class CopyLink extends Component {
	state = {
    loading: true,
    isCopied: false,
  };

  resetCopyButtonText = () => {
    this.setState( { isCopied: false } )
  };

  copyHandler = () => {
    let copyText = document.querySelector("#share-url");
    copyText.select();
    document.execCommand("copy");
    this.setState( { isCopied: true } );
    setTimeout( this.resetCopyButtonText, 3000 );
  };

  forceLoaded = () => {
    this.setState( { loading: false } );
  };

  componentDidMount() {
    if ( this.props.ids !== null ) {
      this.setState( { loading: false } );
    } else {
      setTimeout( this.forceLoaded, 5000 );
    }
  }

  render() {
  	const { loading, isCopied } = this.state;
    const { ids } = this.props;
    const shareURL = `${sharing.home.ogUrl}/my-avatars?ids=${ids}`;

    return (
      <>
      <MetaTags 
        shareURL={shareURL}
      />
      { loading && <p>Loading...</p> }

      { !loading &&
        <Holder>
        	<input id="share-url" type="text" defaultValue={shareURL}/>
          <button id="copy-share-url" className={isCopied ? "copied" : ""} onClick={this.copyHandler}>{isCopied ? "Link copied!" : "Copy link"}</button>
        </Holder>
      }
      </>
    )
  }
}

function mapStateToProps( state ) {
  return {
    ids: state.sharing.ids,
  };
}

export default connect( mapStateToProps )( CopyLink );
